import { render, staticRenderFns } from "./BgContent.vue?vue&type=template&id=ee9ecb84&"
import script from "./BgContent.vue?vue&type=script&lang=js&"
export * from "./BgContent.vue?vue&type=script&lang=js&"
import style0 from "./BgContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports